import { render } from "./PatientDataViewer.vue?vue&type=template&id=03fa0b62&scoped=true"
import script from "./PatientDataViewer.vue?vue&type=script&lang=js"
export * from "./PatientDataViewer.vue?vue&type=script&lang=js"

import "./PatientDataViewer.vue?vue&type=style&index=0&id=03fa0b62&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src931364701/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fa0b62"]])

export default __exports__